import React, { Component } from 'react';
import { Container,Button } from 'react-bootstrap';
import auth from '../../functions/auth'

class Surveyor extends Component {
    Logout = () => {
      auth.logout(() => {
        this.props.history.push('/');
      })
    }
    render(){
      return(
        <Container className="guest">
          <h1>Surveyor</h1>
          <h3>Welcome</h3>
          <Button variant="primary">Edit</Button>
          <Button variant="danger" onClick={this.Logout}>Logout</Button>
        </Container>
      )
    }
    
}

export default Surveyor;
